import { render, staticRenderFns } from "./TipoObraCadastro.vue?vue&type=template&id=d7b4b58e&"
import script from "./TipoObraCadastro.vue?vue&type=script&lang=js&"
export * from "./TipoObraCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports